import { Currencies } from '@/entities/curency'
import { PaymentRequisiteToType } from '@/entities/paymentRequisit'
import {
  TopupsModel,
  TopupsModelMerchant,
  TopupStatus,
  TopupStatusIcons,
  TopupStatusTitles,
} from '@/entities/topups'
import { Roles } from '@/entities/roles'
import { formatRequisitToType } from '@/features/requisites'
import { BaseCard } from '@/shared/components'
import { BaseCopyButton } from '@/shared/components/BaseCopyButton/BaseCopyButton'
import { DealIcon } from '@/shared/components/icons/DealIcon'
import { ItemLayout } from '@/shared/components/ItemLayout/ItemLayout'
import { formatCurrency } from '@/shared/lib/currency'
import { formatDate } from '@/shared/lib/date'
import { getShortenId } from '@/shared/utils/getShortenId'
import { Link } from 'react-router-dom'

type Props = {
  deal: TopupsModel | TopupsModelMerchant
  userRole?: Roles | null
}

export const MobileBlockDeal = ({ deal, userRole }: Props) => {
  const title = TopupStatusTitles[deal.status]
  const iconStatus = TopupStatusIcons[deal.status]

  const subtitle = formatDate(deal.createdAt, 'long')

  const requisite = formatRequisitToType(deal.paymentRequisitToType, deal.paymentRequisitToValue)

  const isMerchant = userRole === Roles.Merchant
  // Курс показывается для мерчантов или для заявок с финальными статусами
  const isFinalStatus = [
    TopupStatus.Paid,
    TopupStatus.OverPaid,
    TopupStatus.PartiallyPaid,
  ].includes(deal.status)
  const showExchangeInfo = isMerchant || isFinalStatus

  const baseInfo = [
    {
      label: 'ID сделки:',
      data: deal.id,
      copyBnt: true,
    },
    ...(isMerchant
      ? [
          {
            label: 'payer_id:',
            data: (deal as TopupsModelMerchant).payerId,
            copyBnt: true,
          },
          {
            label: 'merchant_topup_id:',
            data: (deal as TopupsModelMerchant).merchantTopupId,
            copyBnt: true,
          },
        ]
      : []),
    {
      label: 'Реквизит:',
      data: requisite || '',
    },
    {
      label: 'Банк:',
      data:
        deal.paymentRequisitToType === PaymentRequisiteToType.CardNumber
          ? 'Номер карты'
          : 'Номер телефона',
    },
  ]

  const rateInfo = {
    label: 'Курс:',
    data: deal.exchangeRate ? formatCurrency(deal.exchangeRate, Currencies.RUB) : '',
    copyBnt: false,
  }

  const info = showExchangeInfo ? [...baseInfo, rateInfo] : baseInfo

  return (
    <BaseCard className="md:hidden mb-4 last:mb-0 px-5 text-sm">
      <Link to={deal.id}>
        <div className="flex justify-between mb-6">
          <ItemLayout icon={<DealIcon status={iconStatus} />} title={title} subtitle={subtitle} />
        </div>
        <div className="flex justify-between mb-4">
          <span className="font-klein font-medium text-lg">
            {formatCurrency(deal.amountTo, deal.currencyTo)}
          </span>
          <span className="text-text-secondary">
            {formatCurrency(deal.amountFrom, deal.currencyFrom)}
          </span>
        </div>
        <div className="flex flex-col gap-[10px]">
          {info.map((el) => (
            <div key={el.label} className="flex justify-between">
              <span className="text-text-secondary">{el.label}</span>
              <div className="flex items-center gap-1">
                <span className={el.copyBnt ? `font-medium text-primary` : `font-medium`}>
                  {el.copyBnt ? getShortenId(el.data, 'long') : el.data}
                </span>
                {el.copyBnt && <BaseCopyButton text={el.data} color="primary" size="mini" />}
              </div>
            </div>
          ))}
        </div>
      </Link>
    </BaseCard>
  )
}
